<template>
    <div v-if="viewSetOuttime" style="    text-align: center;position: fixed;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">
        <p>{{ $t('message.paymentSession') }}</p>
    </div>
    <div v-else>
        <div v-if="hideLoading" class="data-loading" style="text-align: center;position: fixed;width: 100%;height: 80%;display: flex;justify-content: center;align-items: center;">
            <van-loading size="35" color="#de5d0a" />
        </div>
        <div v-else class="payment_cart">
            <div v-if="loading" class="data-loading" style="text-align: center;position: fixed;top: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 1;opacity: 0.46;background-color: rgb(33, 33, 33);border-color: rgb(33, 33, 33);">
            <van-loading size="35" color="#de5d0a" />
            </div>
            <div class="timeout">
                <div class="time_text">
                    <div class="text_payment_time" :class="{langKh: addFontKhmer}">{{ $t('message.paymentTime') }}</div>
                    <div class="text_timeout" :class="{langKh: addFontKhmer}">{{ $t('message.timeOut') }}</div>
                </div>
                <div class="count_down">
                    <div class="time_count">{{ timeLeft }}</div>
                </div>
            </div>
            <div style="margin-top: 70px;padding-bottom: 160px;">
                <div class="cart_travel" v-if="checkGoBack()">
                    <div class="travel_trip" :class="{langKh: addFontKhmer}">{{ $t('message.travelTripFrom') }}</div>
                    <div class="travel_summary" :class="{langKh: addFontKhmer}">{{ $t('message.travelSummary') }}</div>
                    <div class="travel_dest_from_to" style="display: flex;">
                        <div style="width: 50%;">
                            {{limitStr(getDesForm(), 20)}}
                        </div>
                        <div style="width: 50%;text-align: end;">
                            {{limitStr(getDesTo(), 20)}}
                        </div>
                    </div>
                    <div class="travel_date" :class="{langKh: addFontKhmer}">
                        <div :class="{langKh: addFontKhmer}" style="width: 40%;">
                            {{ $t('message.departureDates') }} 
                        </div>
                        <div style="width: 60%;text-align: end;">
                            {{limitStr(getDateForm(), 20)}} {{limitStr(getDeparture(), 20)}}
                        </div> 
                    </div>
                    <div class="travel_date" :class="{langKh: addFontKhmer}">
                        <div :class="{langKh: addFontKhmer}" style="width: 40%;">
                            {{ $t('message.arrivalDate') }} 
                        </div>
                        <div style="width: 60%;text-align: end;">
                            {{limitStr(getArrivalDate(), 20)}}
                        </div>
                    
                    </div>
                    <div class="travel_boarding_point" :class="{langKh: addFontKhmer}">
                        <div :class="{langKh: addFontKhmer}" style="width: 40%;">
                            {{ $t('message.boardingPoint') }} 
                        </div>
                        <div style="width: 60%;text-align: end;">
                            {{limitStr(getBoarding(), 20)}}
                        </div>
                    </div>
                    <div class="travel_drop_off" :class="{langKh: addFontKhmer}">
                        <div :class="{langKh: addFontKhmer}" style="width: 40%;">
                            {{ $t('message.dropOffPoint') }} 
                        </div>
                        <div style="width: 60%;text-align: end;">
                            {{limitStr(getDrop(), 20)}}
                        </div>
                    </div>
                    <div class="travel_seat_number" :class="{langKh: addFontKhmer}">
                        <div  :class="{langKh: addFontKhmer}" style="width: 40%;">{{$t('message.seatNumber') }} </div>
                        <div style="width: 60%;text-align: end;">{{limitStr(seatLabel, 20)}}</div>
                    </div>

                    <div style="padding-top: 25px;" :class="{langKh: addFontKhmer}">
                        <div class="travel_contact" :class="{langKh: addFontKhmer}">{{$t('message.contactInformation') }}</div>
                        <div class="contact_name" style="display: flex;" :class="{langKh: addFontKhmer}">
                            <div :class="{langKh: addFontKhmer}" style="width:40%;">{{$t('message.labelName') }}  </div>
                            <div style="width:60%;text-align: end;">{{limitStr(getUsername(), 20)}}</div>
                        </div>
                        <div class="contact_phone" style="display: flex;" :class="{langKh: addFontKhmer}">
                            <div :class="{langKh: addFontKhmer}" style="width:40%;">{{$t('message.labelTelephone') }} </div>
                            <div style="width:60%;text-align: end;">{{getUserphone()}}</div>
                        </div>
                    </div>
                    <div style="padding-top: 25px;">
                        <div class="travel_contact" :class="{langKh: addFontKhmer}">{{$t('message.paymentSummary')}}</div>
                        <div class="contact_name" style="display: flex;" :class="{langKh: addFontKhmer}">
                            <div :class="{langKh: addFontKhmer}" style="color: #000000;font-size: 14px;font-weight: 400;width:40%;">{{$t('message.subTotal')}} </div>
                            <div style="color: #000000;font-size: 16px;font-weight: 500;width:60%;text-align: end;"> {{formatPrice(subTotal)}} USD</div>
                        </div>
                        <div class="contact_name" style="display: flex;" :class="{langKh: addFontKhmer}">
                            <div :class="{langKh: addFontKhmer}" style="color: #000000;font-size: 14px;font-weight: 400;width:40%;"> {{$t('message.discount')}} </div>
                            <div style="color: #000000;font-size: 16px;font-weight: 500;width:60%;text-align: end;"> {{formatPrice(discount)}} USD</div>
                        </div>
                        <div style="padding-top: 5px;border-bottom: 1px solid #000000;opacity: 0.09;"></div>
                        <div class="contact_name" style="display: flex;" :class="{langKh: addFontKhmer}">
                            <div :class="{langKh: addFontKhmer}" style="color: #000000;font-size: 14px;font-weight: 400;width:40%;"> 
                                {{$t('message.grandTotal')}} <br>
                                <span :class="{langKh: addFontKhmer}" style="color: #000000;font-size: 12px;opacity: 0.5;"> {{$t('message.inclVat')}}</span>
                            </div>
                            <div style="color: #000000;font-size: 16px;font-weight: 500;width:60%;text-align: end;"> {{formatPrice(totalPrice)}} USD</div>
                        </div>
                    </div>
                </div>

                <div class="cart_travel" v-if="!checkGoBack()">
                    <div class="travel_trip" :class="{langKh: addFontKhmer}">{{ $t('message.roundTripTicket') }}</div>
                    <div class="travel_summary" :class="{langKh: addFontKhmer}">{{ $t('message.travelSummary') }}</div>
                    <div class="travel_dest_from_to" style="display: flex;">
                        <div style="width: 50%;">
                            {{limitStr(getDesForm(), 20)}}
                        </div>
                        <div style="width: 50%;text-align: end;">
                            {{limitStr(getDesTo(), 20)}}
                        </div>
                    </div>
                    <div class="travel_date">
                        <div :class="{langKh: addFontKhmer}" style="width: 40%;">
                            {{ $t('message.departureDates') }} 
                        </div>
                        <div style="width: 60%;text-align: end;">
                            {{limitStr(getDateForm(), 20)}} {{limitStr(getDeparture(), 20)}}
                        </div> 
                    </div>
                    <div class="travel_date">
                        <div :class="{langKh: addFontKhmer}" style="width: 40%;">
                            {{ $t('message.arrivalDate') }} 
                        </div>
                        <div style="width: 60%;text-align: end;">
                            {{limitStr(getArrivalDate(), 20)}}
                        </div>
                    
                    </div>
                    <div class="travel_boarding_point">
                        <div :class="{langKh: addFontKhmer}" style="width: 40%;">
                            {{ $t('message.boardingPoint') }} 
                        </div>
                        <div style="width: 60%;text-align: end;">
                            {{limitStr(getBoarding(), 20)}}
                        </div>
                    </div>
                    <div class="travel_drop_off">
                        <div :class="{langKh: addFontKhmer}" style="width: 40%;">
                            {{ $t('message.dropOffPoint') }} 
                        </div>
                        <div style="width: 60%;text-align: end;">
                            {{limitStr(getDrop(), 20)}}
                        </div>
                    </div>
                    <div class="travel_seat_number">
                        <div :class="{langKh: addFontKhmer}" style="width: 40%;">{{$t('message.seatNumber') }} </div>
                        <div style="width: 60%;text-align: end;">{{limitStr(seatLabel, 20)}}</div>
                    </div>
                    <div style="padding-top: 10px;">
                        <div class="travel_dest_from_to" style="display: flex;">
                            <div style="width: 50%;">{{limitStr(getDesTo(), 20)}} </div>
                            <div style="width: 50%;text-align: end;">{{limitStr(getDesForm(), 20)}}</div>
                        </div>
                        <div class="travel_date">
                            <div :class="{langKh: addFontKhmer}" style="width: 40%;">{{$t('message.departureDates') }} </div>
                            <div style="width: 60%;text-align: end;">{{limitStr(getDateTo(), 20)}} {{limitStr(getDepartureTo(), 20)}}</div>
                        </div>
                        <div class="travel_date">
                            <div :class="{langKh: addFontKhmer}" style="width: 40%;">{{ $t('message.arrivalDate') }}</div>
                            <div style="width: 60%;text-align: end;">{{limitStr(getArrivalDateBack(), 20)}}</div>
                        </div>
                        <div class="travel_boarding_point">
                            <div :class="{langKh: addFontKhmer}" style="width: 40%;">{{ $t('message.boardingPoint') }}</div>
                            <div style="width: 60%;text-align: end;">{{limitStr(getBoardingB(), 20)}}</div>
                        </div>
                        <div class="travel_drop_off">
                            <div :class="{langKh: addFontKhmer}" style="width: 40%;">{{ $t('message.dropOffPoint') }}</div>
                            <div style="width: 60%;text-align: end;">{{limitStr(getDropB(), 20)}}</div>
                        </div>
                        <div class="travel_seat_number">
                            <div :class="{langKh: addFontKhmer}" style="width: 40%;">{{$t('message.seatNumber') }} </div>
                            <div style="width: 60%;text-align: end;">{{limitStr(seatLabelBack, 20)}}</div>
                        </div>
                    </div>
                    <div style="padding-top: 25px;">
                        <div class="travel_contact" :class="{langKh: addFontKhmer}">{{$t('message.contactInformation') }}</div>
                        <div class="contact_name" style="display: flex;">
                            <div :class="{langKh: addFontKhmer}" style="width: 40%;">{{$t('message.labelName') }} </div>
                            <div style="width: 60%;text-align: end;">{{ limitStr(getUsername(), 20)}}</div>
                        </div>
                        <div class="contact_phone" style="display: flex;">
                            <div :class="{langKh: addFontKhmer}" style="width: 40%;"> {{$t('message.labelTelephone') }}</div>
                            <div style="width: 60%;text-align: end;">{{getUserphone()}}</div>
                        </div>
                    </div>
                    <div style="padding-top: 25px;">
                        <div class="travel_contact" :class="{langKh: addFontKhmer}">{{$t('message.paymentSummary')}}</div>
                        <div class="contact_name" style="display: flex;" :class="{langKh: addFontKhmer}">
                            <div :class="{langKh: addFontKhmer}" style="color: #000000;font-size: 14px;font-weight: 400;width:40%;">{{$t('message.subTotal')}} </div>
                            <div style="color: #000000;font-size: 16px;font-weight: 500;width:60%;text-align: end;"> {{formatPrice(subTotal)}} USD</div>
                        </div>
                        <div class="contact_name" style="display: flex;" :class="{langKh: addFontKhmer}">
                            <div :class="{langKh: addFontKhmer}" style="color: #000000;font-size: 14px;font-weight: 400;width:40%;"> {{$t('message.discount')}} </div>
                            <div style="color: #000000;font-size: 16px;font-weight: 500;width:60%;text-align: end;"> {{formatPrice(discount)}} USD</div>
                        </div>
                        <div style="padding-top: 5px;border-bottom: 1px solid #000000;opacity: 0.09;">
                        </div>
                        <div class="contact_name" style="display: flex;" :class="{langKh: addFontKhmer}">
                            <div :class="{langKh: addFontKhmer}" style="color: #000000;font-size: 14px;font-weight: 400;width:40%;"> 
                                {{$t('message.grandTotal')}} <br>
                                <span :class="{langKh: addFontKhmer}" style="color: #000000;font-size: 12px;opacity: 0.5;"> {{$t('message.inclVat')}}</span>
                            </div>
                            <div style="color: #000000;font-size: 16px;font-weight: 500;width:60%;text-align: end;"> {{formatPrice(totalPrice)}} USD</div>
                        </div>
                    </div>
                </div>
            </div>
            
        
            <div class="btn_payment" v-if="checkGoBack()">
                <div class="default_account" v-if="useDefaultAcc"> 
                    <div class="aba_pay">
                        <div class="aba_img">
                            <img :src="require('@/assets/ABA PAY.svg')" style="width:35px" alt="">
                        </div>
                        <div class="text_aba">
                            <p style="font-size: 14px; font-weight: 600; line-height: 18px;">ABA PAY</p>
                        </div>
                    </div>
                    <div class="savings_account">
                        <div class="paying">
                            <p style="font-size: 16px;font-weight: 600;line-height: 22px;letter-spacing: -0.0041em;">
                                {{defaultAcc.accountName.slice(0,15)}}
                            </p>
                            <p style="font-size: 12px;margin-top: 3px;color:#000000;line-height: 15px;opacity: 0.5;">
                                {{bankAccountFormat(defaultAcc.accountNumber)}} | {{ defaultAcc.currency }}
                            </p>
                        </div>
                        <div class="aba_change" @click="getProcessPaymentPayload()">
                            <p style="color:#de5d0a;font-size: 16px;line-height: 22px;letter-spacing: -0.0041em;">Change <van-icon name="arrow-down" /></p>
                        </div>
                    </div>
                </div>
                <button v-if="isActive" @click="getProcessPayment()" :class="{langKh: addFontKhmer }">{{$t('message.payNow') }} ${{formatPrice(totalPrice)}}</button>
                <button v-else class="actives" :class="{langKh: addFontKhmer }">{{$t('message.payNow') }} ${{formatPrice(totalPrice)}}</button>
            </div> 

            <div class="btn_payment" v-if="!checkGoBack()">
                <div class="default_account" v-if="useDefaultAcc">
                    <div class="aba_pay">
                        <div class="aba_img">
                            <img :src="require('@/assets/ABA PAY.svg')" style="width:35px" alt="">
                        </div>
                        <div class="text_aba">
                            <p style="font-size: 14px; font-weight: 600; line-height: 18px;">ABA PAY</p>
                        </div>
                    </div>
                    <div class="savings_account">
                        <div class="paying">
                            <p style="font-size: 16px;font-weight: 600;line-height: 22px;letter-spacing: -0.0041em;">
                                {{defaultAcc.accountName.slice(0,15)}}
                            </p>
                            <p style="font-size: 12px;margin-top: 3px;color:#000000;line-height: 15px;opacity: 0.5;">
                                {{bankAccountFormat(defaultAcc.accountNumber)}} | {{ defaultAcc.currency }}
                            </p>
                        </div>
                        <div class="aba_change" @click="getProcessPaymentPayload()">
                            <p style="color:#de5d0a;font-size: 16px;line-height: 22px;letter-spacing: -0.0041em;">Change <van-icon name="arrow-down" /></p>
                        </div>
                    </div>
                </div>
                <button v-if="isActive" @click="getProcessPayment()" :class="{langKh: addFontKhmer }">{{$t('message.payNow') }} ${{formatPrice(totalPrice)}}</button>
                <button v-else class="actives" :class="{langKh: addFontKhmer }">{{$t('message.payNow') }}  ${{formatPrice(totalPrice)}}</button>
            </div>
           
            <div v-if="alertSessionExpired">
                <div class="van-overlay" style="z-index: 2001;"></div>
                <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
                    <div class="van-dialog__header"></div>
                    <div class="van-dialog__content">
                        <div class="van-dialog__message van-dialog__message--has-title">{{$t('message.sessionExpired')}}</div>
                    </div>
                    <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                        <button type="button" @click="cancelBooking()" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                            <div class="van-button__content">
                                <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.close')}}</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="alertSomethingWrong">
                <div class="van-overlay" style="z-index: 2001;"></div>
                <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
                    <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.somethingWentWrong')}}</div>
                    <div class="van-dialog__content">
                        <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.pleaseTryItAgain')}}</div>
                    </div>
                    <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                        <button type="button" @click="cancelBooking()" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                            <div class="van-button__content">
                                <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.close')}}</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="alertPaymentNotSuccess">
                <div class="van-overlay" style="z-index: 2001;"></div>
                <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
                    <div class="van-dialog__header"></div>
                    <div class="van-dialog__content">
                        <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.paymentNotSuccess')}}</div>
                    </div>
                    <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                        <button type="button" @click="closedNotSuccess()" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                            <div class="van-button__content">
                                <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.close')}}</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

     <!-- alert Dialog -->
    <div class="modal" v-if="ShowDialog">
        <div class="van-overlay" style="z-index: 2001;"></div>
        <div class="van-popup van-popup--center van-dialog" role="dialog" tabindex="0" aria-labelledby="VET EXPRESS" style="z-index: 2001;">
            <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information') }}</div>
            <div class="van-dialog__content">
                <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.ask') }}</div>
            </div>
            <div class="van-hairline--top van-dialog__footer">
                <button type="button" @click="onCancel()" class="van-button van-button--default van-button--large van-dialog__cancel">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.no') }}</span>
                    </div>
                </button>
                <button type="button" @click="goToHome()" class="van-button van-button--default van-button--large van-dialog__confirm van-hairline--left">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.yes') }}</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
 
    <div v-if="paymentCartErrorIn">
        <div class="van-overlay" style="z-index: 2001;"></div>
        <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
            <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
            <div class="van-dialog__content">
                <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.msgInternet')}}</div>
            </div>
            <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                <button type="button" @click="closedPaymentError()" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
var intervalTimer;
import moment from 'moment';
import {Loading} from "vant";
import axios from 'axios';
import qs from "qs";
export default {
    components: {
        [Loading.name]: Loading
    },
    data() {
        return {
            url: localStorage.getItem("url"),
            bearer: localStorage.getItem("bearer"),
            currentDate:  moment().format('YYYY-MM-DD'),
            hideLoading: true,
            addFontKhmer: false,
            ShowDialog: false,    
            loading: false,
            selectedTime: 0,
            timeLeft: '00:00',
            endTime: '0',
            times: [{sec: 420},],
            timers:[],
            seatLabel:[],
            seatLabelBack:[],
            subTotal: 0,
            discount: 0,
            totalPrice: 0,
            test: 23456789,
            payment: {
                amount: localStorage.getItem('total'),
                account: localStorage.getItem('transactionId'),
                useDefault: false,
                currency: "USD",
            },
            defaultAcc: {
                accountName: "",
                accountNumber: "",
                currency: "",
            },
            paymentToken: "",
            isActive: true,
            useDefaultAcc: false,
            alertSessionExpired: false,
            alertSomethingWrong: false,
            alertPaymentNotSuccess: false,
            paymentCartErrorIn: false,
            viewSetOuttime:  false,
        }
    },
    methods: {
        limitStr (string, limit) {
            let str = string;

            if (typeof str === 'string' && str.length > limit) {
                str = str.slice(0, limit) + '...';
            }
            
            return str;
        },
        bankAccountFormat(account){
            return account.substr(0,3)+' '+account.substr(3,3)+' '+account.substr(6,3);
        },
        closedPaymentError() {
            this.paymentCartErrorIn = false;
        },

        onCancel() {
            this.ShowDialog = false;
        },

        goToHome() {
            this.ShowDialog = false;
            this.cancelBooking();
        },

        closedNotSuccess() {
            this.alertPaymentNotSuccess = false;
        },

        checkGoBack() {
            let check = false;
            if(localStorage.getItem('dateTo') == null) {
                check = true;
            }
            return check; 
        },

        /* timeout */
        setTime(seconds) {
            clearInterval(intervalTimer);
            this.timer(seconds);
        },

        timer(seconds) {
            const now = Date.now();
            const end = now + seconds * 1000;
            this.displayTimeLeft(seconds);
            this.selectedTime = seconds;
            this.displayEndTime(end);
            this.countdown(end);
        },

        countdown(end) {
            intervalTimer = setInterval(() => {
                const secondsLeft = Math.round((end - Date.now()) / 1000);
                if(secondsLeft === 0) {
                    this.endTime = 0;
                }
                if(secondsLeft < 0) {
                    clearInterval(intervalTimer);
                    // return this.cancelBooking();
                    this.viewSetOuttime = true;
                }
                this.displayTimeLeft(secondsLeft)
            }, 1000);
        },

        displayTimeLeft(secondsLeft) {
            const minutes = Math.floor((secondsLeft % 3600) / 60);
            const seconds = secondsLeft % 60;
            this.timeLeft = `${zeroPadded(minutes)}:${zeroPadded(seconds)}`;
        },

        displayEndTime(timestamp) {
            const end = new Date(timestamp);
            const hour = end.getHours();
            const minutes = end.getMinutes();
            this.endTime = `${hourConvert(hour)}:${zeroPadded(minutes)}`
        },

        /* end timeout */
        getDesForm() {
            return localStorage.getItem('destinationFrom');
        },

        getDesTo() {
            return localStorage.getItem('destinationTo');
        },

        getDateForm() {
            return localStorage.getItem('dateFrom');
        },

        getDeparture() {
            return localStorage.getItem('departure');
        },

        getArrivalDate() {
            return localStorage.getItem('arrivalDate');
        },

        getDepartureTo() {
            return localStorage.getItem('departureback');
        },

        getDateTo() {
            return localStorage.getItem('dateTo');
        },

        getArrivalDateBack() {
            return localStorage.getItem('arrivalDateBack');
        },

        getBoarding() {
            return localStorage.getItem('boardingpoint');
        },

        getDrop() {
            return localStorage.getItem('dropoff');
        },

        getBoardingB() {
            return localStorage.getItem('boardingpointB');
        },

        getDropB() {
            return localStorage.getItem('dropoffB');
        },

        getSeatNum() {
            let size = localStorage.getItem('seatlabel');
            let seatArray = size.split(",");
            let lblSeat = "";
            for (let i = 0; i < seatArray.length; i++) {
                if (seatArray[i] != ",") {
                    if(i > 0){
                        lblSeat += ", ";
                    }
                    lblSeat += seatArray[i];
                }
            }
            this.seatLabel = lblSeat;
        },

        getSeatBack() {
            let sizeBack = localStorage.getItem('seatlabelback');
            let seatArray = sizeBack.split(",");
            let lblSeatBack = "";
            for(let i = 0 ; i < seatArray.length; i++) {
                if(seatArray[i] != ',') {
                    if(i > 0) {
                        lblSeatBack += ", ";
                    }
                    lblSeatBack += seatArray[i];
                }
            } 
            this.seatLabelBack = lblSeatBack;
        },

        getUsername() {
            return localStorage.getItem('fullName');
        },

        getUserphone() {
            return localStorage.getItem('userphone');
        },

        getTotal() {
            let overDue = "2023-06-01";
            if(this.currentDate > overDue) {
                this.totalPrice = parseFloat(localStorage.getItem('total'));
            }else{
                this.totalPrice = parseFloat(localStorage.getItem('total')) + (parseFloat(localStorage.getItem('total')) * 0.1);
            }
        },

        getSubToal() {
            let overDue = "2023-06-01";
            if(this.currentDate > overDue) {
                this.subTotal = parseFloat(localStorage.getItem('total'));
            }else{
                this.subTotal = parseFloat(localStorage.getItem('total')) + (parseFloat(localStorage.getItem('total')) * 0.1);
            } 
        },
     
        formatPrice(value) {
            let val = (value/1).toFixed(2);
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        // API
        resetPaymentPayload() {
            let totals = 0;
            let overDue = "2023-06-01";
            if(this.currentDate > overDue) {
                totals = parseFloat(localStorage.getItem('total'));
            }else{
                totals = parseFloat(localStorage.getItem('total')) + (parseFloat(localStorage.getItem('total')) * 0.1) - this.discount
            }
            this.payment = {
                amount: totals,
                currency: "USD",
                useDefault: false,
                account: localStorage.getItem('transactionId'),
            };
        },
        getDefaultAcc() {
            let totals = 0;
            let overDue = "2023-06-01";
            if(this.currentDate > overDue) {
                totals = parseFloat(localStorage.getItem('total'));
            }else{
                totals = parseFloat(localStorage.getItem('total')) + (parseFloat(localStorage.getItem('total')) * 0.1) - this.discount
            }
            this.$bridge.callHandler("getDefaultAcc", {
                currency: "USD",
                amount: totals
            })
            .then((res) => {
                if (res.accountName != null){
                    this.defaultAcc = res;
                    this.useDefaultAcc = true;
                } else {
                    this.useDefaultAcc = false;
                }
            });
        },

        async getProcessPayment() {
            this.isActive = false;
            // do payment
            this.resetPaymentPayload();
            this.payment.currency = "USD";
            this.payment.amount   = this.totalPrice - this.discount;
            this.payment.account  = localStorage.getItem('transactionId');
            this.payment.useDefault = this.useDefaultAcc;
            this.$bridge.callHandler("doPayment", this.payment).then(() => {});
            setTimeout(()=>{
                // Enable Button Pay Now and Disable Loading
                this.isActive = true;
            }, 1500);
            // this.paymentComplete();
        }, 

        async getProcessPaymentPayload() {
            this.isActive = false;
            // do payment
            this.resetPaymentPayload();
            this.payment.currency = "USD";
            this.payment.amount   = this.totalPrice - this.discount;
            this.payment.account  = localStorage.getItem('transactionId');
            this.payment.useDefault = false;
            this.$bridge.callHandler("doPayment", this.payment).then(() => {});
            setTimeout(()=>{
                // Enable Button Pay Now and Disable Loading
                this.isActive = true;
            }, 1500);
        },

        async paymentComplete() {
            const data = {
                'transactionId': localStorage.getItem('transactionId')
            }
            const url = this.url +'booking/complete';
            let config = {
                method: "POST",
                headers: {
                    "Authorization": this.bearer,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                    "accept": "*/*",
                },
                data: qs.stringify(data),
                url,
            };
            this.loading  = true;
            this.isActive = false;
            axios(config).then((response) => {
                if (response.status == 200) {
                    if(response.data.header.result == true && response.data.header.statusCode == 200) {  
                        this.info = response.data.body;
                        localStorage.setItem("ticketSuccessId", this.info.id);
                        if(this.info.status == 1){ // Complete
                            this.$router.push("/payment-success");
                        } else { // not complete
                            // Enable Button Pay Now and Disable Loading
                            this.isActive = true;
                            this.loading  = false;
                            this.alertPaymentNotSuccess = true;
                        }
                    } else { // Error
                        // Enable Button Pay Now and Disable Loading
                        this.isActive = true;
                        this.loading = false;
                        // popup dialog (Something went wrong, Please try it again.) Click close button dialog => redirect to home page
                        this.alertSomethingWrong = true;
                    }
                }
            }).catch((error) => {console.log(error);});
        },

        async cancelBooking() {
            const data = {
                'transactionId': localStorage.getItem('transactionId'),
            }
            const url = this.url +`booking/cancel`;
            let config = {
                method: "POST",
                headers: {
                    "Authorization": this.bearer,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                    "accept": "*/*",
                },
                data: qs.stringify(data),
                url,
            };
            this.loading = true;
            axios(config).then((response) => {
                this.loading = false;
                if (response.status == 200) {
                    this.$router.push("/Home");
                }
            }).catch((error) => {console.log(error);});
        }

    },
    created() {
        this.$bridge.callHandler("setBarTitle", { title: "Payment", bgColor: "#de5d0a",color: "#ffffff"});
        this.getDefaultAcc();
        if(this.$i18n.locale == "en") {
            this.addFontKhmer = false;
        }else {
            this.addFontKhmer = true;
        }

        if(!navigator.onLine){
            this.paymentCartErrorIn = true;
        }else{
            this.hideLoading = false;
        }

        const timer = this.times;
        for(let i = 0; i<timer.length;i++) {
            this.timers = timer[i].sec;
        }
        this.setTime(this.timers); 

        this.getTotal();
        this.getSubToal();
        
        if(localStorage.getItem('seatlabelback') == '' || localStorage.getItem('seatlabelback') == null) {
            this.getSeatNum();
        }else{
            this.getSeatNum();
            this.getSeatBack();
        }
    },
    mounted() {
        // handle back page
        window.onpopstate = () => {
            this.ShowDialog = true;
        };
        // handle native app payment success
        this.$bridge.registerHandler("getStatus", () => {
            this.paymentComplete(); 
        }); 
    },
    beforeUnmount() {
        window.onpopstate = null;
    },
}
function zeroPadded(num) {
    // 4 --> 04
    return num < 10 ? `0${num}` : num;
}
function hourConvert(hour) {
    // 15 --> 3
    return (hour % 12) || 12;
}
</script>
<style>
   .actives{
        padding: 8px !important;
        width: 100% !important;
        height: 100% !important;
        border-radius: 8px !important;
        color: #FFF !important;
        background: #bbbec8 !important;
    }
    .payment_cart {
        width: 100%;
    }
    .payment_cart .timeout {
        position: fixed;
        top: 0;
        width: 100%;
        background: #FFF;
        padding: 10px 10px 10px 10px;
        display: flex;
        padding: 10px 10px 10px 10px;
        box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;
    }
    .payment_cart .timeout .time_text {
        width: 80%;
    }
    .payment_cart .timeout .time_text .text_payment_time {
        font-weight: 600;
        font-size: 17px;
    }
    .payment_cart .timeout .time_text .text_timeout {
        font-size: 14px;
    }
    .payment_cart .timeout .count_down {
        width: 20%;
    }
    .payment_cart .timeout .count_down .time_count {
        border: 1px solid #de5d0a;
        text-align: center;
        padding: 7px;
        border-radius: 8px;
        background: #de5d0a;
        color: #FFF;
        font-weight: 500;
    }
    .cart_travel {
        border-radius: 8px;
        margin: 15px;
        padding: 10px;
        box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
    }
    .cart_travel .travel_trip {
        text-align: center;
        color: #FFF;
        font-weight: 500;
        padding: 8px;
        border-radius: 8px;
        background: #de5d0a;
    }
    .cart_travel .travel_summary {
        margin-top: 10px;
        font-weight: 600;
        font-size: 18px;
    }
    .cart_travel .travel_dest_from_to {
        font-weight: 500;
        margin-top: 10px;
        display: flex;
    }
    .cart_travel .travel_date {
        display: flex;
        margin-top: 10px;
    }
    .cart_travel .travel_boarding_point {
        display: flex;
        margin-top: 10px;
    }
    .cart_travel .travel_drop_off {
        display: flex;
        margin-top: 10px;
    }
    .cart_travel .travel_seat_number {
        display: flex;
        margin-top: 10px;
    }
    .cart_travel .travel_contact {
        margin-top: 7px;
        font-size: 18px;
        font-weight: 600;
    }
    .cart_travel .contact_name {
        margin-top: 10px;
    }
    .cart_travel .contact_phone {
        margin-top: 10px;
    }
    .btn_payment {
        position: fixed;
        width: 100%;
        bottom: 0;
        padding: 7px 15px 15px 15px;
        background: #FFF;
        box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
    }
    .btn_payment button {
        color: #fff;
        font-weight: 600;
        padding: 10px;
        width: 100%;
        border-radius: 8px;
        border: none;
        background: #de5d0a;
        letter-spacing: -0.0041em;
    }
    .btn_payment .total_price {
        display: flex;
        padding-bottom: 15px;
    }
    .btn_payment .total_price .total {
        width: 50%;
        font-size: 19px;
        font-weight: 500;
    }
    .btn_payment .total_price .price {
        width: 50%;
        text-align: end;
        font-size: 19px;
        font-weight: 500;
    }
    .btn_payment .default_account {
        padding-top: 8px;
        padding-bottom: 15px;
    }
    .aba_pay {
        display: flex;
        width: 100%;
    }
    .aba_pay .aba_img {
        width:10%;
        display: flex;
        align-items: center;
    }
    .aba_pay .text_aba {
        width: 80%;
        display: flex;
        align-items: center;
        padding-left: 12px;
    }
    .savings_account {
        margin-top: 16px;
        display: flex;
    }
    .savings_account .paying {
        width: 70%;
    }
    .savings_account .aba_change {
        width: 30%;
        text-align: end;
        font-weight: 600;
    }
</style>
